<template>
  <v-container>
    <v-row class="text-center">
      <!-- <v-col cols="12">
        <v-img
          :src="require('../assets/logo.png')"
          class="my-3"
          contain
          height="200"
        />
      </v-col> -->

      <v-col class="mb-4">
        <div class="text-h2 font-weight-black my-5">
          <strong :style="{ color: setting.COLOR }">SAS </strong>
          <strong :style="{ color: setting.COLOR }">Data </strong>
          <v-icon color="black" size="150">mdi-magnify </v-icon>
          <strong :style="{ color: setting.BACKGROUNDCOLOR }"> Viewer</strong>
        </div>
        <p class="text-subtitle-2 font-weight-regular">
          A <strong class="green--text">SAS7BDAT</strong> file is a database
          storage file created by Statistical Analysis System (SAS) software.
          <br />It contains a binary encoded dataset used for advanced
          analytics, business intelligence, data management, predictive
          analytics, and more.
        </p>
        <p class="subtitle-1 font-weight-regular">
          <strong class="green--text">SAS7BDAT</strong
          >文件是由赛仕软件（SAS）软件创建的数据库存储文件。<br />它包含一个二进制编码的数据集，用于高级分析、商业智能、数据管理、预测性分析等方面。
        </p>
        <p class="text-body-1 red--text text--lighten-1 font-weight-regular">
          Note: if you do not use the translation function, all data is only
          stored in your browser, will not do any interaction with the server!
        </p>
        <p class="text-body-1 red--text text--lighten-1 font-weight-regular">
          友情提示：如果不使用翻译功能，所有数据都只在存储在您的浏览器中，不会与服务器做任何交互！
        </p>

        <p class="subheading font-weight-regular blue--text">
          You are welcomed to reach out author to give suggestions directly!
        </p>
        <p class="subheading font-weight-regular blue--text">
          欢迎大家直接与作者联系，提出建议!
          <v-chip
            class="ma-2"
            color="blue"
            outlined
            pill
            href="mailto:yejianfeng186@163.com"
          >
            Jianfeng YE
            <v-icon right>mdi-account-outline</v-icon>
          </v-chip>
        </p>
        <p class="subheading font-weight-regular green--text">
          If you are using XPT files, please use<br />如果您使用的是XPT文件，请使用
          <a href="http://www.ctrial.cc/xptviewer/index.html" target="_blank"
            >XPT Viewer</a
          >
          ！
        </p>
      </v-col>
    </v-row>
    <!-- <v-row v-if="false">
      <v-col>
        <div v-if="tlf">
          <div v-if="tlf.Title">
            <p v-for="title in tlf.Title" :key="title.Order">{{title.Value}}</p>
          </div>
          <div v-if="tlf.Container">
            <div
              style="display:flex;color:red;border-style:solid;border-width:1px;border-color:1px;"
            >
              <div style="display:flex;width:20%;"></div>
              <div style="display:flex;width:80%;align-items: end;">
                <div v-for="group in tlf.Container.Head.Description" :key="group.Order">
                  <div
                    style="display:flex;justify-content: center;"
                    v-for="layer in group.Layel"
                    :key="layer.Order"
                  >
                    <div
                      v-for="block in layer.Block"
                      :key="block.Order"
                      style="width:200px;color:blue;text-align: center;"
                    >{{block.Value}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div style="color:red;border-style:solid;border-width:1px;border-color:green;">
              <div style="display:flex;" v-for="record in tlf.Container.Body" :key="record.Order">
                <div style="display:flex;width:20%;">
                  <div
                    v-for="block in record.Class"
                    :key="block.Order"
                    style="width:100%;color:blue;text-align: left;"
                  >{{block.Value}}</div>
                </div>
                <div style="display:flex;width:80%;">
                  <div
                    v-for="block in record.Description"
                    :key="block.Order"
                    style="width:200px;color:blue;text-align: center;"
                  >{{block.Value}}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="tlf.Foot">
            <p v-for="foot in tlf.Foot" :key="foot.Order">{{foot.Value}}</p>
          </div>
        </div>
      </v-col>
    </v-row>-->
    <v-row v-if="boolTranslate">
      <v-progress-linear
        color="orange"
        height="10"
        indeterminate
        striped
      ></v-progress-linear>
    </v-row>
    <v-row>
      <v-col>
        <div
          :class="['drag-area', boolDropActive ? 'drag-area-active' : '']"
          @dragenter="boolDropActive = true"
          @dragleave="boolDropActive = false"
        >
          <v-icon color="#2e94c4" large>mdi-cloud-upload</v-icon>
          <div class="upload-title text-h5">Drop file or click to open</div>
          <input
            type="file"
            ref="fileupload"
            multiple
            accept=".sas7bdat"
            @change="getFileList"
          />
        </div>
      </v-col>
    </v-row>
    <v-card class="mb-4" v-if="fileSASList.length > 0" outlined tile>
      <v-list-item
        class="file-item"
        :style="{ backgroundColor: file.backgroundcolor }"
        v-for="(file, index) in fileSASList"
        :key="index"
        dense
      >
        <v-list-item-avatar>
          <v-icon class="mx-2" :color="file.color">mdi-file</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <span class="mx-2" :style="{ color: file.color }"
            >{{ file.name }} ({{ file.size }})</span
          >
        </v-list-item-content>
        <v-list-item-action>
          <v-btn class="mr-2" icon>
            <v-icon color="red" @click="removeFile(index)">mdi-delete</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <!-- <v-row v-for="(file,index) in arrFileList" :key="index" color="light-blue" outlined dark> -->
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mr-2" color="red" dark @click="clearFileList">
          <v-icon>mdi-delete</v-icon>Clear File List
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-row>
      <v-col md="4" xs="12" class="d-flex flex-row">
        <v-select
          v-model="strParseType"
          :items="arrParseType"
          item-text="text"
          item-value="value"
          label="Parse Type"
          @change="loadData()"
          outlined
        ></v-select>
      </v-col>
      <v-col md="8" xs="12" class="d-flex flex-row">
        <!-- <v-file-input
          v-model="fileSASList"
          placeholder="Upload your XPT file"
          label="xpt file input"
          @change="loadData($event)"
          color="orange darken-2"
          accept=".xpt"
          prepend-icon="mdi-file-upload"
          outlined
          multiple
          show-size
        >
          <template v-slot:selection="{ text }">
            <v-chip text-color="white" label color="orange darken-2">{{ text }}</v-chip>
          </template>
        </v-file-input>-->
        <v-chip class="ma-2" color="green" text-color="white">{{
          arrDataset.length
        }}</v-chip>
        <v-select
          v-model="objSAS"
          :items="arrDataset"
          item-text="name"
          item-value="data"
          label="Dataset List"
          outlined
          return-object
        >
          <!-- <template v-slot:item="{item}">
                {{item["text"]}}
                <template v-if="item['size']">
                  ({{item["size"]}})
                </template>
          </template>-->
        </v-select>
      </v-col>
    </v-row>

    <template v-if="arrDataset.length">
      <v-card class="px-3 my-6">
        <v-row>
          <v-col>
            <v-data-table
              class="mt-3 melodie-orange"
              :headers="arrVariableDesHeaders"
              :items="objSAS['variable']"
              :items-per-page="15"
              dense
            ></v-data-table>
          </v-col>
        </v-row>
        <v-row class="mt-6">
          <v-col cols="7"> </v-col>
          <v-col cols="2">
            <v-btn class="" color="success" @click="downloadCsv" block
              >Download</v-btn
            >
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="strSearch"
              prepend-inner-icon="mdi-magnify"
              clear-icon="mdi-close-circle"
              clearable
              label="Search"
              outlined
              dense
              :append-outer-icon="boolSearch ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append-outer="boolSearch = !boolSearch"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-data-table
              class="ctrial-blue"
              :headers="objSAS['headers']"
              :items="objSAS['data']"
              :search="strSearch"
              :items-per-page="10"
              dense
            >
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>
    </template>
  </v-container>
</template>
<style>
.ctrial-orange tr:hover {
  background: #ffb74d !important;
  color: #e65100;
}
.ctrial-orange tr.v-data-table__selected {
  background: #ffb74d !important;
  color: #e65100;
  font-weight: bolder;
}
.ctrial-blue tr:hover {
  background: #bbdefb !important;
  color: #0d47a1;
}
.ctrial-blue tr.v-data-table__selected {
  background: #bbdefb !important;
  color: #0d47a1;
  font-weight: bolder;
}
.ctrial-green tr:hover {
  background: #c5e1a5 !important;
  color: #33691e;
}
.ctrial-green tr.v-data-table__selected {
  background: #c5e1a5 !important;
  color: #33691e;
  font-weight: bolder;
}

.drag-area {
  border: 2px dashed rgb(143, 193, 235);
  height: 150px;
  width: 100%;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
}

.drag-area-active {
  background: #e3f2fd;
}
.drag-area:hover {
  border: 2px solid #2e94c4;
}

.file-item:hover {
  /* background: #e3f2fd; */
  border: 1px solid #2e94c4;
  border-radius: 5px;
}
.upload-icon {
  color: #2e94c4;
}

.drag-area input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
</style>
<script>
import { readSas7bdat } from "@/plugins/node-sas7bdat2json.js";
import { mapState } from "vuex";
import { utils, writeFile } from "xlsx";

export default {
  name: "SasDataViewer",
  data: () => ({
    fileSASList: [],
    arrObs: [],
    objSAS: {},
    arrSASShowHeaders: [],
    arrBasicStatistics: [],
    strXPTVer: null,
    strSearch: null,
    strMessage: null,
    boolSearch: false,
    boolTranslate: false,
    boolSnackbar: false,
    boolDropActive: false,
    objDatasetDes: {},
    intVars: 0,
    intObs: 0,
    strOrgin: "en",
    strDist: "zh",
    strTransType: "XPORT",
    strEncodingType: "ANSI",
    strParseType: "ansi",
    strSourceCode: "",
    arrDataset: [],
    arrLanguage: [
      { value: "en", text: "English" },
      { value: "zh", text: "中文" },
    ],
    arrParseType: [
      { value: "ansi", text: "ANSI" },
      { value: "utf8", text: "UTF-8" },
    ],
    arrVariable: [],
    arrVariableDesHeaders: [
      {
        class: "orange white--text",
        text: "ID",
        align: "left",
        value: "id",
        width: "10%",
        filterable: false,
      },
      {
        class: "orange white--text",
        text: "Variable",
        align: "left",
        value: "variable",
        width: "20%",
        filterable: false,
      },
      {
        class: "orange white--text",
        text: "Length",
        align: "left",
        value: "length",
        width: "10%",
        filterable: false,
      },
      {
        class: "orange white--text",
        text: "Type",
        align: "left",
        value: "type",
        width: "10%",
        filterable: false,
      },
      {
        class: "orange white--text",
        text: "Format",
        align: "left",
        value: "format",
        width: "10%",
        filterable: false,
      },
      {
        class: "orange white--text",
        text: "Label",
        align: "left",
        value: "label",
        width: "40%",
        filterable: false,
      },
      // {
      //   class: "orange white--text",
      //   text: "Informat",
      //   align: "left",
      //   value: "Informat",
      //   width: "10%",
      //   filterable: false
      // }
    ],
    arrBasicStatisticsHeaders: [
      {
        class: "green--text",
        text: "Name",
        align: "left",
        value: "NAME",
        width: "10%",
        filterable: false,
      },
      {
        class: "green--text",
        text: "N",
        align: "left",
        value: "COUNT",
        width: "10%",
        filterable: false,
      },
      {
        class: "green--text",
        text: "Mean(SD)",
        align: "left",
        value: "MEAN",
        width: "30%",
        filterable: false,
      },
      {
        class: "green--text",
        text: "Median(Q1:Q3)",
        align: "left",
        value: "MEDIAN",
        width: "30%",
        filterable: false,
      },
      {
        class: "green--text",
        text: "Min:Max",
        align: "left",
        value: "RANGE",
        width: "20%",
        filterable: false,
      },
    ],
    tlf: {
      Type: "table",
      Title: [
        {
          Order: 1,
          Value:
            "Demographics and patient characteristics at baseline - Randomized population",
        },
      ],
      Container: {
        Head: {
          Class: [],
          Description: [
            {
              Order: 1,
              Layel: [
                {
                  Order: 1,
                  Block: [{ Order: 1, Value: "Placebo" }],
                },
              ],
            },
            {
              Order: 2,
              Layel: [
                {
                  Order: 1,
                  Block: [{ Order: 1, Value: "Q2W/Up150 Q2W" }],
                },
              ],
            },
            {
              Order: 3,
              Layel: [
                {
                  Order: 1,
                  Block: [{ Order: 1, Value: "All" }],
                },
                {
                  Order: 2,
                  Block: [
                    { Order: 1, Value: "All1" },
                    { Order: 2, Value: "All2" },
                  ],
                },
              ],
            },
          ],
        },
        Body: [
          {
            Order: 1,
            Class: [{ Order: 1, Value: "Age" }],
            Description: [],
          },
          {
            Order: 2,
            Class: [{ Order: 1, Value: "Number" }],
            Description: [
              { Order: 1, Value: "102" },
              { Order: 2, Value: "103" },
              { Order: 3, Value: "104" },
            ],
          },
        ],
      },
      Foot: [
        {
          Order: 1,
          Value:
            "The safety and anti-alirocumab antibody population patients are tabulated according to treatment actually received (as treated). ",
        },
        {
          Order: 2,
          Value:
            "For the other populations, patients are tabulated according to their randomized treatment. ",
        },
        {
          Order: 3,
          Value: "dis_std_populations_a_t.sas",
        },
      ],
    },
  }),
  methods: {
    bytesToSize(bytes) {
      // console.log(bytes);
      let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes === 0) return "n/a";
      let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      if (i === 0) return bytes + " " + sizes[i];
      // console.log(bytes / Math.pow(1024, i));
      // console.log((bytes / Math.pow(1024, i)).toFixed(2));
      return (bytes / Math.pow(1024, i)).toFixed(2) + " " + sizes[i];
    },
    getFileList(e) {
      this.boolDropActive = false;
      let files = e.target.files || e.dataTransfer.files;
      // console.log(files);
      if (!files) return;
      [...files].forEach((file) => {
        let objFile = {};
        objFile["file"] = file;
        objFile["name"] = file["name"];
        // console.log(objFile["name"]);
        objFile["size"] = this.bytesToSize(file["size"]);
        objFile["status"] = undefined;
        objFile["color"] = "#039BE5";
        objFile["backgroundcolor"] = "#FFFFFF";
        this.fileSASList.push(objFile);
      });
      this.loadData();
      this.$refs.fileupload.value = null;
    },
    removeFile(key) {
      this.fileSASList.splice(key, 1);
      this.loadData();
    },
    clearFileList() {
      this.fileSASList = [];
      this.arrDataset = [];
    },
    loadData() {
      this.objDatasetDes = {};
      this.strXPTVer = "";
      this.strTransType = "";
      this.strEncodingType = "";
      this.intVars = 0;
      this.intObs = 0;
      this.arrDataset = [];
      // console.log(this.fileSASList);
      if (this.fileSASList && this.fileSASList.length) {
        // console.log(this.fileSASList);
        // let arrDataset = [];
        this.fileSASList.forEach((f) => {
          let file = f["file"] || f;
          // console.log(file);
          let reader = new FileReader();
          // reader.readAsBinaryString(this.fileSASList);
          reader.readAsBinaryString(file);
          reader.onload = (res) => {
            let objOption = {
              input: "data",
              output: "data",
              encoding: "utf8",
              property_only: false,
            };
            // console.log(this.strParseType);
            if (this.strParseType == "utf8") {
              objOption.encoding = "utf8";
            }
            console.log(res.target.result);
            console.log(objOption);
            let objSasData = readSas7bdat(
              res.target.result,
              file.name,
              objOption
            );
            console.log(objSasData);
            let objSAS = {};

            if (f["name"]) {
              objSAS["name"] = f["name"].split(".").slice(0)[0];
            }

            objSAS["data"] = objSasData["data"];

            let arrVariable = objSasData["property"];
            let arrHeaders = [];

            arrVariable.forEach((header) => {
              let objHeader = {
                class: "blue white--text",
                text: header["variable"].toUpperCase(),
                value: header["variable"],
                sortable: true,
                filterable: true,
              };
              arrHeaders.push(objHeader);
            });
            objSAS["variable"] = arrVariable;
            objSAS["headers"] = arrHeaders;
            this.arrDataset.push(objSAS);
            this.objSAS = this.arrDataset[0];
            // console.log(this.arrDataset);
          };
        });
      } else {
        this.arrVariable = [];
        this.arrBasicStatistics = [];
        this.arrObs = [];
      }
    },
    downloadData() {
      if (!this.objSAS) return;

      let strNewFileName = this.objSAS["name"];

      let wsData = utils.json_to_sheet(this.objSAS["data"]);
      let arrSheet = [{ name: strNewFileName, value: wsData }];
      let workbook = utils.book_new();
      arrSheet.forEach((item) => {
        utils.book_append_sheet(workbook, item.value, item.name);
      });
      writeFile(workbook, strNewFileName + ".xlsx", {
        bookType: "xlsx",
        bookSST: false,
        type: "array",
      });
      // let eleLink = document.createElement("a");

      // eleLink.download = strNewFileName + ".xlsx";
      // eleLink.style.display = "none";
      // let blob = new Blob(
      //   [
      //   writeFile(workbook, {
      //       bookType: "xlsx",
      //       bookSST: false,
      //       type: "array",
      //     }),
      //   ],
      //   {
      //     type: "application/octet-stream",
      //   }
      // );
      // eleLink.href = URL.createObjectURL(blob);

      // document.body.appendChild(eleLink);
      // eleLink.click();
      // document.body.removeChild(eleLink);
    },
    // downloadCsv() {
    //   // console.log(this.objSAS);
    //   if (this.objSAS) {
    //     // let strFileName = this.fileSASList["name"];
    //     // console.log(this.objSAS["MEMBER"]);

    //     let strNewFileName = this.objSAS["name"];

    //     let csvFile = parse(this.objSAS["data"]);
    //     // console.log(csvFile);
    //     let eleLink = document.createElement("a");
    //     eleLink.download = strNewFileName + ".csv";
    //     eleLink.style.display = "none";
    //     let blob = new Blob(["\ufeff" + csvFile], {
    //       type: "text/csv;charset=utf-8;",
    //     });
    //     eleLink.href = URL.createObjectURL(blob);

    //     document.body.appendChild(eleLink);
    //     eleLink.click();
    //     document.body.removeChild(eleLink);
    //   }
    // },
  },
  computed: mapState({
    setting: "setting",
  }),
};
</script>
